module.exports = __webpack_public_path__ + "img/banner1.a8555425.jpg";